import type { ReactNode } from 'react';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import U3203, { U3203ROLES } from './U3203';
import U3203AiMissionList from './components/U3203AiMissionList';
import U3203AiMissionForm from './components/U3203AiMissionForm';

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3203Routes: RouteObject[] = [
  {
    path: 'U3203',
    element: <U2000RequireRole allowedRoles={[U3203ROLES.READ]} />,
    children: [
      {
        path: '',
        element: <U3203 />,
        children: [
          { index: true, element: <U3203AiMissionList /> },
          { path: ':id', element: <U3203AiMissionForm /> },
        ],
      },
    ],
  },
];

export default U3203Routes;
